"use client"

import type { TreatmentConfig } from "@/platform/experiments/types"
import { trackExperimentInclusion } from "@/platform/observability/analytics/v2/experiments"

export function trackExperiments(...experiments: TreatmentConfig<unknown>[]): void {
  experiments.forEach((config) => {
    if (!config) return

    trackExperimentInclusion({
      feature_name: config.featureName,
      tracking_key: config.trackingKey,
      treatment_name: config.treatmentName,
    })
  })
}
